import React from "react";
import MarkdownView from "react-showdown";

import { useGql } from "../Core/gqlHooks";
import { queryProduitsPage } from "../Core/services";
import PageLayout from "../Components/pageLayout/PageLayout";
import PageSubHeader from "../Components/pageSubHeader/PageSubHeader";
import { iProduct } from "../Core/interface";
import { mediaUrl, usePageSeo } from "../Core/utils";

import "./Produits.scss";

const Produits = () => {
  const { data, loading } = useGql({
    query: queryProduitsPage,
  });

  const page = data?.pageProduct?.data?.attributes;
  const products: iProduct[] = data?.products?.data ?? [];
  const coupsDeCoeur = products.filter((p) => p.attributes.coupDeCoeur);

  usePageSeo({
    title: page?.pageTitle,
    keywords: page?.keywords,
  });

  return (
    <PageLayout
      className="produits-container"
      contentClassName="produits"
      title="Les Produits"
    >
      <PageSubHeader title={page?.title} intro={page?.intro} />

      <div className="coup-de-coeurs-container">
        <h2>Nos coup de coeur</h2>
        <div className="coup-de-coeurs">
          {!loading &&
            coupsDeCoeur.map((product) => {
              const image = product.attributes.image?.data?.attributes;
              const imageUrl = mediaUrl(image?.hash, image?.ext);
              return (
                <div className="coup-de-coeur" key={product.id}>
                  <div
                    className="coup-de-coeur-bg"
                    style={{
                      backgroundImage: `url(${imageUrl})`,
                    }}
                  >
                    <img
                      className="coup-de-coeur-img"
                      src={imageUrl}
                      alt={product.attributes.name}
                    />
                  </div>
                  <div className="coup-de-coeur-desc">
                    <MarkdownView markdown={product.attributes.description} />
                  </div>
                  <a
                    className="coup-de-coeur-link link"
                    target="_blank"
                    rel="noreferrer"
                    href={product.attributes.link}
                  >
                    {product.attributes.link}
                  </a>
                </div>
              );
            })}
        </div>
      </div>
      <div className="marques-container">
        <h2>Les marques</h2>
        <div className="marques">
          {!loading &&
            products.map((product) => {
              const image = product.attributes.image?.data?.attributes;
              const imageUrl = mediaUrl(image?.hash, image?.ext);
              return (
                <div className="marque" key={product.id}>
                  <img
                    className="marque-img"
                    src={imageUrl}
                    alt={product.attributes.name}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </PageLayout>
  );
};

export default Produits;
